import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import * as yup from 'yup';

const useAddressFormValidationSchema = () => {
	const { t } = useTranslation();

	return useMemo(
		() =>
			yup.object({
				country: yup
					.object()
					.shape({ label: yup.string(), value: yup.number() })
					.required(t('Required'))
					.nullable(),
				apartmentBuilding: yup.string(),
				line1: yup.string(),
				line2: yup.string(),
				cityRegion: yup.string(),
				postCodeZip: yup.string(),
			}),
		[t],
	);
};

export default useAddressFormValidationSchema;
